// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import interpellationAnswerEntity from './entities/interpellation-answer.json';
import interpellationAnswerMenu from '../pages/interpellation-answer/menu.json';
import interpellationAnswerFullForm from '../pages/interpellation-answer/forms/full.json';
import interpellationAnswerContextForm from '../pages/interpellation-answer/forms/context.json';
import interpellationAnswerMiniForm from '../pages/interpellation-answer/forms/mini.json';
import interpellationAnswerLookupForm from '../pages/interpellation-answer/forms/lookup.json';
import interpellationAnswerTableView from '../pages/interpellation-answer/views/table.json';
import interpellationAnswerCardsView from '../pages/interpellation-answer/views/cards.json';
import interpellationAnswerCalendarView from '../pages/interpellation-answer/views/calendar.json';
import interpellationAnswerDashboardView from '../pages/interpellation-answer/views/dashboard.json';

/** Тип запису «Відповідь Уряду» зі сторінками пакета: меню, форми та подання з pages/interpellation-answer/. */
export const interpellationAnswerDefinition: IRecordTypeDefinition = {
  ...interpellationAnswerEntity,
  views: assembleViewSet({
      table: interpellationAnswerTableView,
      cards: interpellationAnswerCardsView,
      calendar: interpellationAnswerCalendarView,
      dashboard: interpellationAnswerDashboardView,
  }),
  form: interpellationAnswerFullForm,
  forms: { full: interpellationAnswerFullForm, context: interpellationAnswerContextForm, mini: interpellationAnswerMiniForm, lookup: interpellationAnswerLookupForm },
  menu: interpellationAnswerMenu,
} as IRecordTypeDefinition;
